module.exports = __webpack_public_path__ + "static/img/tabbt2024_2.64c9d62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbt2024_2.png
// module id = TRgn
// module chunks = 1